import { errorMessage } from '@client/components/_ui/feedback/error-message/ErrorMessage';
import { message } from '@client/components/_ui/feedback/message';
import type { TrpcClient } from '@client/trpc/client';
import { downloadBlob } from '@client/utils';

/**
 * Export invoice data to a CSV file for Xero import
 * @param trpcClient
 * @param invoiceIds Array of invoice IDs to export
 * @returns Promise<void>
 */
export async function exportInvoice(trpcClient: TrpcClient, invoiceIds: number[]) {
    try {
        message.loading('Generating CSV file. Please wait...', 0);

        const { rows, fields } = await trpcClient.invoice.exportInvoice.fetch({
            invoiceIds,
        });

        const { parse } = await import('json2csv');
        const csv = parse(rows, { fields: Object.assign([], fields) });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

        downloadBlob(blob, `invoices-${new Date().toISOString()}.csv`);
        message.success('Export Invoice file generated.');
    } catch (e) {
        message.destroy();
        errorMessage.show(e);
    }
}
